module.exports = __webpack_public_path__ + "img/p3.947be1b5.png";